import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';

export default function UpdateEvents() {


  const [selectedUserType, setSelectedUserType] = useState(null);
  const [userTypeId, setUserTypeId] = useState([]);
  const [username, setUsername] = useState('');
  const [flag, setflag] = useState(false);
  const [disciplineId, setDisciplineChange] = useState(null);
  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [collegedisciplinetype, setCollegeDisciplineTypeChange] = useState(null);

  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [reloadUserID, setReloadUserID] = useState(false);
  const [getGenerateUserID, setGenerateUserID] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [userid, setUserID] = useState('');
  const [password, setPassword] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [submittedUserID, setSubmittedUserID] = useState('');
  const [submittedPassword, setSubmittedPassword] = useState('');
  const [isFirstSubmit, setFirstSubmit] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");

  const [eventData, setEventData] = useState([]);

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [selectedAdmissionYear, setSelectedAdmissionYear] = useState(null);
  const [selectedAdmissionYearID, setSelectedAdmissionYearID] = useState(null);
  const [selectedSemester, setSelectedSemester] = useState(null);
  const [selectedSemesterID, setSelectedSemesterID] = useState(null);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [selectedSchemeID, setSelectedSchemeID] = useState(null);
  const [startDateTime, setStartDateTime] = useState("");
  const [endDateTime, setEndDateTime] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedStatusID, setSelectedStatusID] = useState(null);

  const [errors, setErrors] = useState({});

  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }

  useEffect(() => {

    const fetchAllEvents = async () => {
      try {
        const response = await http.get('/Admin/getAllevent');
        setEventData(response.data);
      }
      catch (error) {
        if (error.response?.data?.http_status === 401 && error.response.data.status_code === "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/admin/");
          }, 5000);
        }
        else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchAllEvents();

  }, []);

  const handleEventChange = (selectedOption) => {
    setSelectedEvent(selectedOption);
    setSelectedEventId(selectedOption.value);
  };

  const handleAdmissionYearChange = (selectedOption) => {
    setSelectedAdmissionYear(selectedOption);
    setSelectedAdmissionYearID(selectedOption.value);
  }

  const handleSemesterChange = (selectedOption) => {
    setSelectedSemester(selectedOption);
    setSelectedSemesterID(selectedOption.value);
  }
  const handleShemeChange = (selectedOption) => {
    setSelectedScheme(selectedOption);
    setSelectedSchemeID(selectedOption.value);
  }
  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setSelectedStatusID(selectedOption.value);
  }
  const validateForm = () => {
    let hasError = false;
    let newErrors = {};

    if (!selectedEvent) {
      newErrors.event_id = "Event is required.";
      hasError = true;
    }

    if (!selectedAdmissionYear) {
      newErrors.admissionYear = "Admission Year is required.";
      hasError = true;
    }

    if (!selectedSemester) {
      newErrors.semester_id = "Semester is required.";
      hasError = true;
    }

    if (!selectedScheme) {
      newErrors.scheme_id = "Scheme is required.";
      hasError = true;
    }

    if (!startDateTime) {
      newErrors.startDateTime = "Start Date & Time is required.";
      hasError = true;
    }

    if (!endDateTime) {
      newErrors.endDateTime = "End Date & Time is required.";
      hasError = true;
    }

    if (!selectedStatus) {
      newErrors.status_id = "Status is required.";
      hasError = true;
    }

    setErrors(newErrors);
    return !hasError;
  };



  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    window.location.reload();
  }

  const cancelForm = () => {
    window.location.reload();
  };





  let cid = localStorage.getItem("collegeid");

  const handlefirstsubmit = () => {
    if (!validateForm()) {
      toast.error("Please fill mandatory fields");
      return;
    }
    setShowConfirmModal(true);

  };

  const handleSaveEventData = () => {


    // Actual submit begins
    const payloads = {
      event_id: selectedEventId,
      admission_year: selectedAdmissionYearID,
      semester_id: selectedSemesterID,
      scheme_id: selectedSchemeID,
      startDateTime: startDateTime,
      endDateTime: endDateTime,
      status: selectedStatusID,

    };

    http.post('/College/saveCollegeUserData', payloads)
      .then((response) => {

        if (response.data.status_code === 'ERR43' && response.data.http_status === 401) {
          toast.error("Email ID already exists");

          return;
        }
        if (response.data.status_code === 'ERR64' && response.data.http_status === 500) {
          toast.error("Something went wrong. Please try again");
          setReloadUserID(true);
          setErrors(prev => ({
            ...prev,
            userid: "Note: New user ID is generated. Please submit again"
          }));
          return;
        }


        if (response.data.status_code === 'MSG11') {
          toast.success("User data inserted successfully");
          setTimeout(() => {
            setShowConfirmModal(true);
          }, 1000); // 2000ms = 2 seconds

        } else {
          toast.error("Failed to save User Data");
          setShowConfirmModal(false);

        }
      })
      .catch((error) => {
        setReloadUserID(false);
        setShowConfirmModal(false);

        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 && error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else if (error.response?.data?.status_code === 'ERR64' && status === 500) {
          toast.error("Something went wrong. Please try again");
          setReloadUserID(true);
          setErrors(prev => ({
            ...prev,
            userid: "Note: New user ID is generated. Please submit again"
          }));
        }
        if (error.response?.data?.http_status === 401 && error.response?.data?.status_code === "ERR43") {
          toast.error(message);
        }
        else {
          toast.error("Something went wrong");
        }
      });

  };



  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      textAlign: 'left', // added
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
      textAlign: 'left', // added
    }),
    singleValue: (provided) => ({
      ...provided,
      textAlign: 'left', // optional, for selected value
    }),
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>


        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Event Time Extension</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="col-md-12 txt-aln pdg14">
                        <div className="row">
                          <div className="col">

                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Event<span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <Select
                                  id="event_id"
                                  name="event_id"
                                  maxMenuHeight={200}
                                  menuPlacement="auto"
                                  styles={customStyles}
                                  className="form-control ht"
                                  options={
                                    eventData
                                      .map(event => ({
                                        value: event.id,
                                        label: event.event_name
                                      }))
                                  }
                                  value={selectedEvent}
                                  onChange={handleEventChange}
                                />
                                {errors.event_id && <p className="text-danger">{errors.event_id}</p>}
                              </div>
                            </div>

                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Admission Year<span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <Select
                                  id="admissionYear"
                                  name="admissionYear"
                                  maxMenuHeight={200}
                                  menuPlacement="auto"
                                  styles={customStyles}
                                  className="form-control ht"
                                  options={[
                                    { value: 2024, label: '2024' },
                                    { value: 2025, label: '2025' }
                                  ]}
                                  value={selectedAdmissionYear}
                                  onChange={handleAdmissionYearChange}
                                />
                                {errors.admissionYear && <p className="text-danger">{errors.admissionYear}</p>}
                              </div>
                            </div>

                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Semester<span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <Select
                                  id="semester_id"
                                  name="semester_id"
                                  maxMenuHeight={200}
                                  menuPlacement="auto"
                                  styles={customStyles}
                                  className="form-control ht"
                                  options={[
                                    { value: 1, label: 'Semester 1' },
                                    { value: 2, label: 'Semester 2' },
                                    { value: 3, label: 'Semester 3' },
                                    { value: 4, label: 'Semester 4' },
                                    { value: 5, label: 'Semester 5' },
                                    { value: 6, label: 'Semester 6' },
                                    { value: 7, label: 'Semester 7' },
                                    { value: 8, label: 'Semester 8' }
                                  ]}
                                  value={selectedSemester}
                                  onChange={handleSemesterChange}
                                />
                                {errors.semester_id && <p className="text-danger">{errors.semester_id}</p>}
                              </div>
                            </div>
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Scheme<span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <Select
                                  id="scheme_id"
                                  name="scheme_id"
                                  maxMenuHeight={200}
                                  menuPlacement="auto"
                                  styles={customStyles}
                                  className="form-control ht"
                                  options={[
                                    { value: 1, label: 'Scheme 1' },
                                    { value: 2, label: 'Scheme 2' },
                                    { value: 3, label: 'Scheme 3' },
                                    { value: 4, label: 'Scheme 4' }
                                  ]}
                                  value={selectedScheme}
                                  onChange={handleShemeChange}
                                />
                                {errors.scheme_id && <p className="text-danger">{errors.scheme_id}</p>}
                              </div>
                            </div>

                            <div class="row mb-3">
                              <label class="col-md-5 txt-aln-lft">
                                Start Date & Time <span class="errorclr">*</span>
                              </label>
                              <div class="col-md-7">
                                <input
                                  type="datetime-local"
                                  id="startDateTime"
                                  name="startDateTime"
                                  class="form-control ht"
                                  value={startDateTime}
                                  onChange={(e) => setStartDateTime(e.target.value)}
                                />
                                {errors.startDateTime && <p className="text-danger">{errors.startDateTime}</p>}
                              </div>
                            </div>

                            <div class="row mb-3">
                              <label class="col-md-5 txt-aln-lft">
                                End Date & Time <span class="errorclr">*</span>
                              </label>
                              <div class="col-md-7">
                                <input
                                  type="datetime-local"
                                  id="endDateTime"
                                  name="endDateTime"
                                  class="form-control ht"
                                  value={endDateTime}
                                  onChange={(e) => setEndDateTime(e.target.value)}
                                />

                                {errors.endDateTime && <p className="text-danger">{errors.endDateTime}</p>}

                              </div>
                            </div>
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Status<span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <Select
                                  id="status_id"
                                  name="status_id"
                                  maxMenuHeight={200}
                                  menuPlacement="auto"
                                  styles={customStyles}
                                  className="form-control ht"
                                  options={[
                                    { value: 1, label: 'Active' },
                                    { value: 2, label: 'Inactive' }
                                  ]}
                                  value={selectedStatus}
                                  onChange={handleStatusChange}
                                />
                                {errors.status_id && <p className="text-danger">{errors.status_id}</p>}
                              </div>
                            </div>










                          </div>
                        </div>
                        <div>
                          <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Submit</button>
                          <input className="btn btn-light" type="reset" style={{ border: '2px solid black' }} value="Cancel" onClick={cancelForm} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {showConfirmModal && (
              <div className="modal-backdrop show" style={{ opacity: 'unset' }}>
                <div className="modal d-block" tabIndex="-1" role="dialog">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Confirmation</h5>
                      </div>
                      <div className="modal-body">
                        <p>Do you want to save?
                        </p>
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={() => {
                          setShowConfirmModal(false);
                          handleSaveEventData();
                          setTimeout(() => {
                            cancelForm();
                          }, 1000);
                        }}>
                          Save
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={() => setShowConfirmModal(false)}>
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </Template>
    </>
  );
}
